import React from 'react';
import { Text, mergeClassNames } from '@clockout-dev/design-elements';
import styles from '../../treasury/elements/styles/pills.module.scss';
import { NOTIFICATION_SEVERITY } from '../../../constants/notifications.constants';
import { SEVERITY_ICONS, SEVERITY_LABELS, SEVERITY_TONES } from './notificationSeverityPill.constants';

/**
 * Inline icon + label severity indicator shared by the header bell menu and
 * the Notifications table. Same structure as `SupportStatusPill` /
 * `treasury/elements/TransactionStatusPill` and reuses their tones:
 * error → danger, warning → warning, info → neutral.
 */
function NotificationSeverityPill({ severity }) {
    const safe = SEVERITY_TONES[severity] ? severity : NOTIFICATION_SEVERITY.INFO;
    const tone = SEVERITY_TONES[safe];
    const icon = SEVERITY_ICONS[safe];
    const label = SEVERITY_LABELS[safe] || safe;

    return (
        <span className={mergeClassNames([styles.pill, tone])}>
            {icon ? (
                <span className={styles.icon} aria-hidden="true">
                    {icon}
                </span>
            ) : null}
            <Text as="span" size="xs" className={styles.label}>
                {label}
            </Text>
        </span>
    );
}

export default NotificationSeverityPill;
